export default "__VITE_ASSET__FTbBBkTN__"